import { type IHydratedWidget } from '../../../../../hydrate/IHydrationContext.ts';
import { wrapWithMarginStyleDiv } from '../../../../directives/margin/generateMarginStyle.ts';
import { type IHtmlRenderContext } from '../../../IWidgetType.ts';
import { type IRowWidget } from './IRowWidget.ts';

export function renderRowHtml(
  widget: IHydratedWidget<IRowWidget>,
  context: IHtmlRenderContext,
): string {
  const totalColSpan = countTotalColSpan(widget.children ?? []);

  const childrenHtml = context.renderChildren(
    widget.children ?? [],
    (childWidget, html) =>
      `<td style="vertical-align:top;width:${calculateColumnWidth(totalColSpan, childWidget)}%;">${html}</td>`,
  );

  const tableHtml = `<table style="width:100%;border-collapse:collapse;"><tr>${childrenHtml}</tr></table>`;

  return wrapWithMarginStyleDiv(tableHtml, widget.directives?.margin);
}

function countTotalColSpan(widgets: IHydratedWidget<any>[]): number {
  return widgets.reduce(
    (acc, widget) => acc + (widget.layout?.colSpan ?? 1),
    0,
  );
}

function calculateColumnWidth(
  totalColSpan: number,
  widget: IHydratedWidget<any>,
): number {
  return (
    Math.floor((100 / totalColSpan) * (widget.layout?.colSpan ?? 1) * 100) / 100
  );
}
